import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveModalShell from '../ResponsiveModalShell';
import SelectionFooter from '../SelectionFooter';
import {useSourceSelection} from '../useSourceSelection';

/**
 * Instrument-only sources (e.g. Favoritenlisten): pick a list, drill in and
 * select the instruments inside. No whole-item multi-selection.
 */
function InstrumentSelectionFlow({open, onClose, onSelectProducts, SourceComponent, backToSourceLabel}) {
  const selection = useSourceSelection({open, onClose, onSelectProducts});

  return (
    <ResponsiveModalShell
      open={open}
      onClose={onClose}
      footer={
        <SelectionFooter
          onBack={selection.goBack}
          onConfirm={selection.confirm}
          confirmDisabled={!selection.hasSelection}
          inDetail={selection.inDetail}
          backToSourceLabel={backToSourceLabel}
        />
      }
    >
      <SourceComponent
        onDetailsClick={selection.drillInto}
        selectedItem={selection.activeItem}
        onInstrumentSelect={selection.toggleInstrument}
        onSelectAll={selection.selectAllInstruments}
        selectedInstruments={selection.selectedInstruments}
      />
    </ResponsiveModalShell>
  );
}

InstrumentSelectionFlow.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectProducts: PropTypes.func.isRequired,
  SourceComponent: PropTypes.elementType.isRequired,
  backToSourceLabel: PropTypes.string,
};

export default InstrumentSelectionFlow;
